export default __webpack_public_path__ + "static/media/close-modal.19efd865.svg";